module.exports = __webpack_public_path__ + "static/media/294305.55d3425c.png";